import styles from './product-version.module.scss';
import { Col, Row } from 'reactstrap';
import PageTitle from '../../page-title/page-title';
import { Box, Container } from '@frontend-workspace/react-shared-lib';
import ProductVersionGrid from '../product-version-grid/product-version-grid';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface ProductVersionProps { }

export function ProductVersion(props: ProductVersionProps) {
  const { t } = useTranslation();

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title={t("app.productVersion")} />
            <ProductVersionGrid />
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default ProductVersion;